<template>
  <div>
    <el-dialog
      title="请阅读协议(点击确定代表同意协议)"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      top="35vh">
      <span>
        <a href="javascript:;" style="color: #000000;" v-for="cc in datas" :key="cc.id" @click="openInformation(cc)">《{{cc.name}}》</a>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateChcke">确 定</el-button>
      </span>
    </el-dialog>

    <div class="Orderinfordiv" id="Agreementinformain">
      <AgreementInfor :data_id="data.id" div_name="Agreementinformain" div_content="aboutHtml_3"></AgreementInfor>
    </div>

  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import AgreementInfor from '@/admin/views/A_zujian/AgreementInfor.vue'//协议详情组件
  export default {
    components: {
      'AgreementInfor': AgreementInfor,
    },
    data() {
      return {
        uuu:{
          pageNum:1,
          pageSize:8
        },
        datas:'',
        data:'',
        dialogVisible: false
      };
    },
    mounted(){
      this.getData_xieyi();
    },
    methods: {
      //打开通知详情
      openInformation(data){
        this.data="";
        this.data=data;
        sessionStorage.setItem("notice_infor_data",JSON.stringify(this.data));
        document.getElementById('Agreementinformain').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      //查询
      getData_xieyi() {
        commonAPI('W_queryAgreement',this.uuu).then(res => {
          this.datas = res.data.data.rows;
          //this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
        })
      },
      //修改前台确认处
      updateChcke(){
        this.$emit('Father_updateChcke', "");
        this.dialogVisible = false
      },
      handleOpen(){
        this.dialogVisible=true;
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
    }
  };
</script>

<style scoped>
  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
    text-align: left;
  }
   /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/components/LoginPage/xieyiCheck.vue